/**
 * Footer
 */

import React from 'react'

const Footer = () => {

  return (

    <footer>
    <p>
      <a href="https://discord.com/channels/752545699568287874/1012668588903125042" target="_blank"> Discord</a> |
      <a href="mailto:mark.webster@wanadoo.fr?Subject=Hello%20again" target="_blank"> Contact</a>
  </p>
    </footer>
  )
}

export default Footer
